<template>
  <div>
    <div class="container">
      <breadcrumbs :breadcrumbs="breadcrumbs" />
    </div>
      <GuestPriceWarning/>
    <div class="container">
      <div ref="h1Category" class="category-header">
        <h1 v-if="getH1">{{ getH1 }}</h1>
        <h1 v-else>{{ getCategoryName() }}</h1>
      </div>
      <products-list v-if="category.id" 
        :category="category"
        :seo="seo"
        :filter="filter"
        :h1hide="!!getH1"
      />
    </div>
  </div>
</template>

<script>
import {rememberExpiresMixin, headCatalogMixin} from '@/mixins';
import {DbConfig} from '@/models/db-config';
import {Category} from '@/models/category';
import {Seo, SeoHeaders} from '@/models/seo';
import {Filters} from '@/models/filters';
import Breadcrumbs from '@/components/breadcrumbs';
import ProductsList from '@/components/catalog/products-list';
import GuestPriceWarning from '@/components/catalog/guest-price-warning';

export default {
  components: {
    Breadcrumbs,
    ProductsList,
    GuestPriceWarning,
  },
  mixins: [
    rememberExpiresMixin,
    headCatalogMixin
  ],
  computed: {
    breadcrumbs() {
      let breadcrumbs = [];
      let category = this.category;
      let categoryTree = [category];
      while (category.parent) {
        categoryTree.push(category.parent);
        category = category.parent;
      }
      let categoryUrl = '/';
      for (const category of categoryTree.reverse()) {
        categoryUrl += `${category.slug}/`;
        if (category.parent || categoryTree.length === 1) {
          breadcrumbs.push({
            name: this.getCategoryLocaleData(this.seoHeader?.category?.id === category.id && this.filter
                        ? this.seoHeader : category),
            link: categoryUrl,
          });
        }
      }
      return breadcrumbs;
    },
    slug() {
      const urlParts = this.$route.path.split('/').filter(x => x);
      return urlParts[urlParts.length - 1];
    },
    categoryLocaleData() {
      return this.category.category_translations?.find(x => x.language.slug === this.$i18n.locale) || {};
    },
    getH1(){
      try{
        const top_text = this.seo?.category_seo_text_obzor[0].top_text[0]
        const txt = top_text.value.block_content?.find(x => x.type === 'h1') || {}
        return txt.value[this.$i18n.locale]
      } catch(e) {
      }
      return null
    },
  },
  async asyncData(context) {
    try {
      let [slug, filter] = ''
      const urlParts = context.route.path.split('/').filter(x => x);
      slug = urlParts[urlParts.length - 1];

      if (process.env.VENDOR === 'wellfar') {
        let filtersSeo = await Filters.config({count_loading: true}).get()
        let filters = filtersSeo.map(a => a.slug);
        if (filters.indexOf(urlParts[urlParts.length - 1]) >= 0) {
          filter = urlParts[urlParts.length - 1];
          slug = urlParts[urlParts.length - 2];
        }
      }

      const [dbConfig, category] = await Promise.all([
        DbConfig.config({count_loading: true}).first(),
        Category.config({count_loading: true}).find(slug),
      ]);
      if (filter) {
        const [seo, seoHeader] = await Promise.all([
          Seo.config({count_loading: true}).params({
            category: category.id,
            filter: filter
          }).first(),
          SeoHeaders.config({count_loading: true}).params({
            category: category.id, filter:
            filter
          }).first()
        ]);
        return {
          dbConfig: dbConfig,
          category: category,
          seo: seo,
          seoHeader: seoHeader,
          filter: filter
        }
      } else {
        const seo = await Seo.config({count_loading: true}).params({category: category.id}).first();
        return {
          dbConfig: dbConfig,
          category: category,
          seo: seo,
        }
      }
    } catch (e) {
      context.error({statusCode: e.response.status});
    }
  },
  methods: {
    getCategoryLocaleData(category) {
      if (category.category_translations) {
        return category.category_translations?.find(x => x.language.slug === this.$i18n.locale).name || {};
      } else {
        return category.header_translations?.find(x => x.language.slug === this.$i18n.locale).header || {};
      }
    },
    getCategoryName() {
      if (!this.filter) {
        return this.categoryLocaleData.name
      } else {
        if (this.seoHeader.header_translations) {
          return this.seoHeader.header_translations?.find(x => x.language.slug === this.$i18n.locale).header || {};
        } else {
          return this.category.category_translations?.find(x => x.language.slug === this.$i18n.locale).name || {};
        }
      }
    }
  },
}
</script>
